import { FC, useMemo } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Box, Tab, Tabs } from "@mui/material";
import { pages } from "../../../utils/common";

const TAB_SEGMENTS = [
  "obep",
  "courses",
  "subjects",
  "classes",
  "syllabus",
  "scoring-rubrics",
] as const;

const tabIndexFromPath = (pathname: string): number => {
  const base = pages.academics.path;
  if (!pathname.startsWith(base)) {
    return 0;
  }
  const rest = pathname.slice(base.length).replace(/^\//, "");
  const first = rest.split("/")[0] ?? "";
  if (first === "obep") {
    return 0;
  }
  if (first === "courses") {
    return 1;
  }
  if (first === "subjects") {
    return 2;
  }
  if (first === "classes") {
    return 3;
  }
  if (first === "syllabus") {
    return 4;
  }
  if (first === "scoring-rubrics") {
    return 5;
  }
  return 0;
};

const AcademicsLayout: FC = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const tabValue = useMemo(() => tabIndexFromPath(pathname), [pathname]);

  const base = pages.academics.path;

  return (
    <Box data-testid="academics-layout">
      <Tabs
        value={tabValue}
        onChange={(_, value: number) => {
          navigate(`${base}/${TAB_SEGMENTS[value]}`);
        }}
        variant="scrollable"
        scrollButtons="auto"
        sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}
        data-testid="academics-primary-tabs"
      >
        <Tab label="OBEP" />
        <Tab label="Courses" />
        <Tab label="Subjects" />
        <Tab label="Classes" />
        <Tab label="Syllabus" />
        <Tab label="Scoring rubrics" />
      </Tabs>
      <Outlet />
    </Box>
  );
};

export default AcademicsLayout;
